import Vue from 'vue'
import md5 from 'js-md5';

export function copyToClip(text) {
    return new Promise((resolve, reject) => {
        try {
            const input = document.createElement("textarea");
            input.setAttribute("readonly", "readonly");
            input.value = text;
            document.body.appendChild(input);
            input.select();
            if (document.execCommand("copy")) document.execCommand("copy");
            document.body.removeChild(input);
            Vue.prototype.$message({
                message: '复制成功！',
                type: 'success',
                duration: 1500
            })
            resolve(text);
        } catch (error) {
            Vue.prototype.$message({
                message: '复制失败！',
                type: 'error'
            })
            reject(error);
        }
    });
}

// 深拷贝
export function deepClone(source) {
    if (!source && typeof source !== "object") {
        throw new Error("error arguments", "deepClone");
    }
    const targetObj = source.constructor === Array ? [] : {};
    Object.keys(source).forEach((keys) => {
        if (source[keys] && typeof source[keys] === "object") {
            targetObj[keys] = deepClone(source[keys]);
        } else {
            targetObj[keys] = source[keys];
        }
    });
    return targetObj;
}

// 格式化时间
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null;
    }
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
        date = time;
    } else {
        if (typeof time === "string") {
            if (/^[0-9]+$/.test(time)) {
                // support "1548221490638"
                time = parseInt(time);
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), "/");
            }
        }

        if (typeof time === "number" && time.toString().length === 10) {
            time = time * 1000;
        }
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    };
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
            return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        return value.toString().padStart(2, "0");
    });
    return time_str;
}

export function getTimestamp() {
    return Math.floor(Date.now() / 1000).toString();
}


// 全局参数校验
export function globalParams(obj) {
    obj.t = Date.now().toString();
    let requestData = {
        s: "",
    };
    let SIGNKEY = `296ESfrEL2llejjsrLmzOW3jfj062zMR`;
    
    let sign = "";
    let arr = [];

    Object.keys(obj)
        .sort()
        .forEach((item) => {
            requestData[item] = obj[item];
            arr.push(obj[item]);
        });
    sign = arr.join("");
    requestData.s = md5(sign + SIGNKEY);
    return requestData;
}